<div class="table-buttons-group">
  <ng-container *ngFor="let dComponent of dynamicComponents">
    <dynamicComponentLoader [dynamicComponent]="dComponent"> </dynamicComponentLoader>
  </ng-container>
</div>
